import type { LinkComponentProps } from '@remotely/ui-kit';
import { Link } from 'react-router';

export default function RouterLink({ href, ...props }: LinkComponentProps) {
    return (
        <Link
            {...props}
            to={href}
        />
    );
}

export function ReloadDocumentLink({ href, ...props }: LinkComponentProps) {
    return (
        <Link
            {...props}
            to={href}
            reloadDocument
        />
    );
}
